import { createDraftSafeSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { SupportPanelStateType } from '../reducer/supportPanel.reducer'

const state = (state: RootState) => state.supportPanelStore as SupportPanelStateType

export const selectSupportView = createDraftSafeSelector(state, (s) => s.view)
export const selectSupportConversationId = createDraftSafeSelector(state, (s) => s.conversationId)
export const selectSupportComposeCategory = createDraftSafeSelector(state, (s) => s.composeCategory)
export const selectSupportChatBack = createDraftSafeSelector(state, (s) => s.chatBack)
export const selectSupportChatsFrom = createDraftSafeSelector(state, (s) => s.chatsFrom)
export const selectSupportHasUnread = createDraftSafeSelector(state, (s) => s.unreadConversationIds.length > 0)
export const selectSupportLiveSeq = createDraftSafeSelector(state, (s) => s.liveSeq)
export const selectSupportLiveConversationId = createDraftSafeSelector(state, (s) => s.liveConversationId)
export const selectSupportLiveMessageId = createDraftSafeSelector(state, (s) => s.liveMessageId)
export const selectSupportChats = createDraftSafeSelector(state, (s) => s.chats)
export const selectSupportThreads = createDraftSafeSelector(state, (s) => s.threads)
